module.exports = __webpack_public_path__ + "img/background-1152.bfa6b459.jpg";